<template>
	<i class="icon icon-escala"/>
</template>

<script>
export default {}
</script>
